import React from 'react';

import {
  actions,
  CategoryContext,
  categoryInitialState,
  createCategoryState,
  logger,
  useSportsbookState,
  useSportsbookStateUpdate,
  useSportState,
} from '@apollo/core';

import { isSportsbookCollectionValid, isUrlNamesMatch } from '../utils';

export function SelectedCategoryProvider(props) {
  const [sportsbookState] = useSportsbookState();
  const { selectedCategoryUrlName, selectedSportUrlName } = sportsbookState;

  const { urlName, categories, initialized } = useSportState();

  const selectedCategory = React.useMemo(() => {
    if (!initialized || !isSportsbookCollectionValid(categories)) {
      return null;
    }

    // For provided selected sport we need to check sport url name match
    if (selectedSportUrlName) {
      const sportNameMatches = isUrlNamesMatch(urlName, selectedSportUrlName);

      if (!sportNameMatches) {
        return null;
      }
    }

    let searchPredicate;

    if (selectedCategoryUrlName) {
      searchPredicate = (category) =>
        isUrlNamesMatch(category.urlName, selectedCategoryUrlName);
    } else {
      // No search attributes case
      return undefined;
    }

    return categories.find(searchPredicate);
  }, [
    initialized,
    categories,
    selectedSportUrlName,
    urlName,
    selectedCategoryUrlName,
  ]);

  const handleSportsbookUpdate = useSportsbookStateUpdate();

  const [selectedCategoryState, dispatchSelectedCategoryState] =
    createCategoryState(selectedCategory);

  // Auto-select category
  React.useEffect(() => {
    // Skipping if sport not initialized
    if (selectedCategory === null || selectedCategory === undefined) {
      return;
    }

    // Skipping if selected category not empty
/*    if (selectedCategory === undefined) {
      // Picking first category of the provided sport
      const [category] = categories;

      logger.debug('[category:selected] autoselecting new category', category);

      // Updating selected category in sportsbook state & resetting tournament ids
      category &&
        handleSportsbookUpdate({
          selectedCategoryUrlName: category.urlName,

          selectedTournamentUrlName: null,
        });
      return;
    }*/

    if (selectedCategoryState.id === selectedCategory.id) {
      logger.debug(
        '[category:selected] recieved outer category state update',
        selectedCategory
      );

      dispatchSelectedCategoryState({
        type: actions.CATEGORY_STATE_UPDATE,
        payload: selectedCategory,
      });
    } else {
      logger.debug(
        '[category:selected] reinitializing new category state',
        selectedCategory
      );

      dispatchSelectedCategoryState({
        type: actions.CATEGORY_STATE_UPDATE,
        payload: {
          ...selectedCategory,
          ...categoryInitialState,
        },
      });
    }
  }, [selectedCategory]);

  return (
    <CategoryContext.Provider value={selectedCategoryState}>
      {props.children}
    </CategoryContext.Provider>
  );
}
